// extracted by mini-css-extract-plugin
export default {"SubmitCandidateButton":"styles_SubmitCandidateButton__qUUBl"};